import type { ComponentType, FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

import { PropertyLoansQuestion } from "./PropertyLoansQuestion";
import { PropertyMortgage } from "./PropertyMortgage";
import { PropertyHELOC } from "./PropertyHELOC";
import { PropertyInsuranceQuestion } from "./PropertyInsuranceQuestion";
import { PropertyHomeownersInsurance } from "./PropertyHomeownersInsurance";

function createCachedGetter(
  Inner: FC<FlowCustomComponentProps & { propertyId: number }>,
): (propertyId: number) => ComponentType<FlowCustomComponentProps> {
  const cache = new Map<number, ComponentType<FlowCustomComponentProps>>();

  return (propertyId: number) => {
    const cached = cache.get(propertyId);
    if (cached) return cached;

    const Wrapper = (props: FlowCustomComponentProps) => (
      <Inner {...props} propertyId={propertyId} />
    );

    cache.set(propertyId, Wrapper);
    return Wrapper;
  };
}

export const getLoansQuestionComponent = createCachedGetter(PropertyLoansQuestion);
export const getMortgageComponent = createCachedGetter(PropertyMortgage);
export const getHELOCComponent = createCachedGetter(PropertyHELOC);
export const getInsuranceQuestionComponent = createCachedGetter(PropertyInsuranceQuestion);
export const getInsuranceFormComponent = createCachedGetter(PropertyHomeownersInsurance);
